import React from 'react';
import { isNullOrUndefined } from '../../helpers/object-helpers';
import styles from './ErrorMessage.module.scss';

export interface IErrorMessage {
  isValid: boolean | undefined;
  children?: React.ReactNode;
}

export default function ErrorMessage({ isValid, children }: IErrorMessage) {
  return !isNullOrUndefined(children) && isValid === false ? (
    <small role="alert" className={styles.error}>
      {children}
    </small>
  ) : null;
}
